var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-dropzone',{ref:"dropzone",staticClass:"d-flex flex-row",attrs:{"id":"dropzone","awss3":_vm.awsS3,"options":_vm.dropzoneOptions,"disabled":_vm.disabled},on:{"vdropzone-error":_vm.handleError,"vdropzone-success":_vm.createDocument,"vdropzone-s3-upload-error":_vm.s3UploadError,"vdropzone-s3-upload-success":_vm.s3UploadSuccess}})
}
var staticRenderFns = []

export { render, staticRenderFns }